import { useDispatch, useSelector } from "react-redux";
import CheckoutPaddle from "../pages/CheckoutPaddle";
import { selectAuthStatus, selectLoginState, selectRedirectionPage, setRedirectionPage } from "../features/states/slices";
import Authentication from "../pages/Authentication";
import { MainBody } from "../App";
import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

const nonProjectTopLevelRoutes = new Set([
  "help",
  "download",
  "checkout",
  "confirm",
  "login",
  "forgot-password",
  "confirm-reset-password",
  "settings",
  "launch-animotive",
  "survey",
  "signup-completion",
  "register",
]);

function normalizeRoute(route) {
  if (!route) {
    return null;
  }
  return route.startsWith("/") ? route : `/${route}`;
}

function RedirectWithReset({to}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setRedirectionPage(null));
  }, [dispatch]);

  return <Navigate to={to} replace />;
}

export function LoginRequiredRoute({ element }) {
  const userLoggedIn = useSelector(selectLoginState);
  const authStatus = useSelector(selectAuthStatus);
  const redirectionInPlace = useSelector(selectRedirectionPage);
  const location = useLocation();

  if (authStatus === "checking") {
    return null;
  }

  if (!userLoggedIn) {
    return <Authentication Screen={"signIn"} />;
  }

  const redirectTarget = normalizeRoute(redirectionInPlace);
  if (redirectTarget !== null && location.pathname !== redirectTarget) {
    return <RedirectWithReset to={redirectTarget} />;
  }

  return element;
}

export function MainBodyLoginRequiredRoute({ element }) {
  const userLoggedIn = useSelector(selectLoginState);
  const authStatus = useSelector(selectAuthStatus);
  const redirectionInPlace = useSelector(selectRedirectionPage);
  const location = useLocation();

  if (authStatus === "checking") {
    return null;
  }

  if (!userLoggedIn) {
    return <Authentication Screen={"signIn"} />;
  }

  const redirectTarget = normalizeRoute(redirectionInPlace);
  if (redirectTarget !== null && location.pathname !== redirectTarget) {
    return <RedirectWithReset to={redirectTarget} />;
  }

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const isTopLevelDynamicProjectRoute =
    pathSegments.length === 1 && !nonProjectTopLevelRoutes.has(pathSegments[0]);
  const isProjectsRoute = location.pathname === "/" || isTopLevelDynamicProjectRoute;
  return <MainBody fullWidth={isProjectsRoute}>{element}</MainBody>;
}

export function RegisterRoute() {
  const userLoggedIn = useSelector(selectLoginState);
  const authStatus = useSelector(selectAuthStatus);

  if (authStatus === "checking") {
    return null;
  }

  if (!userLoggedIn) {
    return <Authentication Screen={"signUp"} />;
  }

  return <MainBody />;
}

export function CheckoutRoute() {
  const userLoggedIn = useSelector(selectLoginState);
  const authStatus = useSelector(selectAuthStatus);

  if (authStatus === "checking") {
    return null;
  }

  if (!userLoggedIn) {
    return <Authentication Screen={"signIn"} redirection={"checkout"} />;
  }

  return <CheckoutPaddle />;
}
